import { UploadSummary } from "src/app/views/partials/shared/file-upload/file-upload.component";

export class IAnswerModel {
  id!: string
  answerText: string = ""
  showTextbox!: boolean;
  textboxPlaceholder?: string; //placeholder/example text for the inline textbox
  textboxValue!: string; //used in frontend only
  signer!: string
  tooltip?: string
  approach?: string
  terminationMessage: any
  nextQuestionId?: string
  wizardComplete: boolean = false
  artifactKeys: string[] = []
  documents: UploadSummary[] = []
  answerCode:string=""
  answerType:string=""
  grouping:string=""
  fee:number=0
  extensionPropertyValue?:string

  /*****temp******/
  requiredArtifacts: any[] = []
  selectedArtifact!: null
  visible!:boolean
  responseValue!: string
}

export class AnswerModel extends IAnswerModel {
  constructor(options?: IAnswerModel) {
    super()
    if (options) {
      this.id = options.id
      this.answerText = options.answerText ?? this.answerText;
      this.showTextbox = options.showTextbox
      this.textboxPlaceholder = options.textboxPlaceholder
      this.tooltip = options.tooltip
      this.approach = options.approach
      this.terminationMessage = options.terminationMessage
      this.nextQuestionId = options.nextQuestionId
      this.signer = options.signer
      this.wizardComplete = options.wizardComplete
      this.artifactKeys = options.artifactKeys
      this.requiredArtifacts = options.requiredArtifacts
      this.documents = options.documents || [];
      this.selectedArtifact = options.selectedArtifact
      this.visible = options.visible
      this.responseValue = options.responseValue
      this.answerCode = options.answerCode
      this.answerType = options.answerType
      this.grouping = options.grouping
      this.fee = options.fee ?? this.fee
      this.extensionPropertyValue = options.extensionPropertyValue
    }
  }

  toJSON() {
    return {
      id: this.id,
      answerText: this.answerText,
      showTextbox: this.showTextbox,
      textboxPlaceholder: this.textboxPlaceholder,
      tooltip: this.tooltip,
      approach: this.approach,
      terminationMessage: this.terminationMessage,
      nextQuestionId: this.nextQuestionId,
      signer: this.signer,
      wizardComplete: this.wizardComplete,
      artifactKeys: this.artifactKeys,
      requiredArtifacts: this.requiredArtifacts,
      documents: this.documents,
      selectedArtifact: this.selectedArtifact,
      visible: this.visible,
      responseValue: this.responseValue,
      answerCode: this.answerCode,
      answerType: this.answerType,
      grouping: this.grouping,
      fee: this.fee,
      extensionPropertyValue: this.extensionPropertyValue,
    }
  }
}
